import {Divider, Grid} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { Organization } from "../../models/Organization";
import { NoMembership } from "../../ui/Organization/customer/NoMembership";
import { RentContractsForOrg } from "../../ui/rentContract/Customer/RentContractsForOrg";
import { RentContract } from "../../models/RentContract";
import {
    getRentContractsByOrganization,
} from "../../Services/RentContractService";
import { StorageLocation } from "../../models/StorageLocation";
import { fetchMyOrganization } from "../../Services/OrganizationService";
import StorageTimeline from "../../ui/information/Customer/StorageTimeline";
import {fetchStorageLocationsByOrgId} from "../../Services/StorageLocationService";

export const Contracts = () => {

    const [organization, setOrganization] = useState<Organization | null>(null);
    const [locations, setLocations] = useState<StorageLocation[] | null>(null);
    const [contracts, setContracts] = useState<RentContract[] | null>(null);

    useEffect(() => {
        fetchMyOrganization().then((response) => {
            setOrganization(response);
        });
    }, []);

    useEffect(() => {
        if (organization) {
            getRentContractsByOrganization(organization.id).then((response) => {
                setContracts(response);
            });
        }
    }, [organization]);

    useEffect(() => {
        if (organization) {
            fetchStorageLocationsByOrgId(organization.id)
                .then((data) => {
                    setLocations(data);
                })
        }
    }, [organization]);

    // Refresh data after certain actions (e.g. after creating a location or rent contract)
    function updatePage() {
        fetchMyOrganization().then((response) => {
            setOrganization(response);
        });
    }
    // If user has no organization, show a fallback
    if (!organization) {
        return (
                <NoMembership />
        );
    }

    return (

            <Grid gutter="md">
                <Grid.Col span={12}>
                    {contracts && (
                        <RentContractsForOrg
                            orgId={organization.id}
                            contracts={contracts}
                            onCreatedRentContract={updatePage}
                        />
                    )}
                </Grid.Col>

                <Grid.Col span={12}>
                    <Divider />
                </Grid.Col>

                {/* Timeline for an overview of storage vs. rent contracts, full width */}
                <Grid.Col span={12}>
                    {locations && contracts && (
                        <StorageTimeline storageLocations={locations} rentContracts={contracts} />
                    )}
                </Grid.Col>
            </Grid>
    );
};